export default {
    white: '#ffffff',
};
